import React, { useState } from 'react';

import {
  Flex, Link, Stack, Text,
} from '@chakra-ui/react';
import { isEmpty, uniqBy } from 'lodash';
import { useQuery } from 'react-query';
import { useCounter, useSet } from 'react-use';

import api from 'api';
import Map from 'containers/Map';
import { ActivityTypes } from 'enums/types';
import { formatDatePicker } from 'utils/parsers';

import Accordions from './Accordions';
import { DispatchCard, RouteAccordion } from './Cards';

export default function Routes({ range }) {
  const [routes, setRoutes] = useState([]);
  const [expandedItems, { toggle }] = useSet<number>(new Set([]));
  const [dispatches, setDispatches] = useState([]);
  const [routePage, { inc: paginateRoute }] = useCounter(1);
  const [dispatchPage, { inc: paginateDispatch }] = useCounter(1);
  const { data: routeResponse, isLoading } = useQuery(
    ['dashboard', 'routes', range, routePage],
    () => api().get('/dashboard/routes', {
      params: {
        page: routePage,
        perPage: 10,
        from: formatDatePicker(range.from),
        to: formatDatePicker(range.to),
      },
    }),
    {
      enabled: !!range.to && !!range.from,
      refetchInterval: 10000,
      onSuccess: ({ data }) => {
        if (routePage > 1) {
          setRoutes((prev) => uniqBy([...prev, ...data.data], 'id'));
        } else {
          setRoutes(data.data);
        }
      },
    });

  const { data: dispatchResponse, isFetching: isFetchingDispatch } = useQuery(
    ['dashboard', 'dispatches', range, dispatchPage],
    () => api().get('/dashboard/activities', {
      params: {
        page: dispatchPage,
        type: ActivityTypes.Dispatch,
        perPage: 3,
        from: formatDatePicker(range.from),
        to: formatDatePicker(range.to),
      },
    }),
    {
      enabled: !!range.to && !!range.from,
      onSuccess: ({ data }) => {
        if (dispatchPage > 1) {
          setDispatches((prev) => [...prev, ...data.data]);
        } else {
          setDispatches(data.data);
        }
      },
    });

  return (
    <Stack spacing={8}>
      <Stack>
        <Flex
          width="100%"
          justifyContent="space-between">
          <Text
            variant="xLargeBold"
            color="gray.700">
            Status das Rotas
          </Text>
          <Link href="/table/routes">
            <Text
              variant="xSmallSemiBold"
              color="primary.default">
              Ver todas as Rotas
            </Text>
          </Link>
        </Flex>
        <Map
          routes={routes}
          expandedItems={expandedItems}
          toggleExpanded={toggle}
        />
        <Accordions
          data={routes}
          meta={routeResponse?.data.meta}
          isFetching={isLoading}
          expandedItems={expandedItems}
          toggleExpanded={toggle}
          onPaginate={() => paginateRoute()}
          RenderItem={RouteAccordion}
          keyExtractor={(item) => `route-${item.code}`}
        />
      </Stack>
      <Stack hidden={isEmpty(dispatches)}>
        <Flex
          width="100%"
          justifyContent="space-between">
          <Text
            variant="xLargeBold"
            color="gray.700">
            Status dos Despachos
          </Text>
          <Link href="/table/dispatch">
            <Text
              variant="xSmallSemiBold"
              color="primary.default">
              Ver todos os Despachos
            </Text>
          </Link>
        </Flex>
        <Accordions
          data={dispatches}
          meta={dispatchResponse?.data.meta}
          isFetching={isFetchingDispatch}
          onPaginate={() => paginateDispatch()}
          RenderItem={DispatchCard}
          keyExtractor={(item) => `dispatch-${item.id}`}
        />
      </Stack>
    </Stack>
  );
}
